export default __webpack_public_path__ + "static/media/intern1.48e34155.png";